<div class="op-breadcrumbs">
  <!-- Desktop Version -->
  <nav [attr.aria-label]="text.breadcrumb" class="hidden-for-mobile">
    <ol class="op-breadcrumbs--items">
      @for (item of items; track item; let last = $last) {
        <li
          class="op-breadcrumbs--item"
          data-test-selector="op-breadcrumbs--item"
          >
          @if (!last) {
            @if (isLink(item)) {
              <a [href]="item.href" target="_top">{{ item.text }}</a>
            } @else {
              <a class="op-breadcrumbs--text"
                href="#"
                target="_top">
                {{ item }}
              </a>
            }
          }
          @if (last) {
            <a href="#"
              aria-current="page"
              class="op-breadcrumbs--current"
              target="_self"
              >
              @if (lastItemSection) {
                <span class="op-breadcrumbs--section">{{ lastItemSection }}: </span>
              }
              <b>{{ getText(item) }}</b>
            </a>
          }
        </li>
      }
    </ol>
  </nav>

  <!-- Mobile Version -->
  <nav [attr.aria-label]="text.breadcrumb" class="hidden-for-desktop">
    @if (items.length > 1) {
      <div class="op-breadcrumbs--mobile">
        @if (getHref(items[items.length - 2]); as href) {
          <a class="op-breadcrumbs--back" [href]="href" target="_top">
            <svg arrow-left-icon size="small"></svg>
            {{ getText(items[items.length - 2]) }}
          </a>
        }
      </div>
    }
  </nav>
</div>
